module.exports = __webpack_public_path__ + "assets/icon_loading_white.ad38390.png";